import { OrderRugCollapse } from './order-rug-collapse'

export const OrderRugTab = () => <OrderRugCollapse />
